import React from 'react';

import { ProfileAvatar, ProfilePictureProps } from '../profile-avatar/ProfileAvatar';

import styles from './settings-avatar.module.scss';

type SettingsAvatarProps = {
  title: string;
  detail: string;
} & ProfilePictureProps;

export const SettingsAvatar: React.FC<SettingsAvatarProps> = ({ detail, title, ...props }) => (
  <div className={styles['container']}>
    <div className={styles['header']}>
      <h3>{title}</h3>
      <p className={styles['detail']}>{detail}</p>
    </div>

    <div className={styles['wrapper']}>
      <ProfileAvatar {...props} />
    </div>
  </div>
);
